'use strict'

export default function () {
    const roster = document.querySelector('.orchestra-roster')
    if (!roster) return

    const thresholdPx = 16

    const getHeaderOffset = () => {
        const header = document.querySelector('.global-header')
        return header ? header.offsetHeight : 0
    }

    const isFooterVisible = () => {
        const footer = document.querySelector('.global-footer')
        if (!footer) return false

        const rect = footer.getBoundingClientRect()

        const visiblePx =
            Math.min(rect.bottom, window.innerHeight) -
            Math.max(rect.top, 0)

        const clampedVisiblePx = Math.max(0, visiblePx)
        const ratio = rect.height ? clampedVisiblePx / rect.height : 0

        return ratio >= 0.25
    }

    const updateStickyState = () => {
        const staticView = roster.querySelector('.orchestra-roster__view--static')
        const rosterBody = roster.querySelector('.orchestra-roster__body')
        const stickyView = roster.querySelector('.orchestra-roster__view--sticky')

        if (!stickyView) return

        if (isFooterVisible()) {
            stickyView.classList.remove('is-active')
            return
        }

        const headerOffset = getHeaderOffset()

        if (staticView) {
            const rect = staticView.getBoundingClientRect()

            const staticIsPinned =
                rect.top <= headerOffset + thresholdPx &&
                rect.top >= headerOffset - thresholdPx

            if (!staticIsPinned) {
                const shouldBeActive = rect.bottom <= 0
                stickyView.classList.toggle('is-active', shouldBeActive)
                return
            }
        }

        if (rosterBody) {
            const bodyRect = rosterBody.getBoundingClientRect()
            const shouldBeActive = bodyRect.top <= headerOffset + thresholdPx
            stickyView.classList.toggle('is-active', shouldBeActive)
        }
    }

    const scrollToRosterTop = () => {
        const headerOffset = getHeaderOffset()
        const rosterTop =
            roster.getBoundingClientRect().top +
            window.pageYOffset -
            headerOffset

        window.scrollTo({
            top: rosterTop,
            behavior: 'smooth'
        })
    }

    window.addEventListener('scroll', updateStickyState, { passive: true })
    window.addEventListener('resize', updateStickyState)
    window.addEventListener('orientationchange', updateStickyState)
    window.addEventListener('load', updateStickyState)
    document.addEventListener('DOMContentLoaded', updateStickyState)

    updateStickyState()

    document.addEventListener('click', e => {
        const btn = e.target.closest?.('.orchestra-roster__view-btn')
        if (!btn) return

        scrollToRosterTop()

        updateStickyState()
        window.setTimeout(updateStickyState, 50)
        window.setTimeout(updateStickyState, 250)
    })
}
